import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";

const HeritageDetails = () => {
  const [cookies] = useCookies(["token", "user", "id"]);
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");

  const user_id = cookies.id;

  const destinations = [
    {
      name: "Agra",
      img: "agra.jpg",
      desc: "Home of the iconic Taj Mahal, Agra showcases Mughal grandeur and architectural brilliance.",
    },
    {
      name: "Ajmer",
      img: "ajmer.jpg",
      desc: "Famous for Ajmer Sharif Dargah, a major spiritual and historical destination.",
    },
    {
      name: "Amritsar",
      img: "amritsar.jpg",
      desc: "The spiritual center of Sikhism, home to the Golden Temple and rich Punjabi culture.",
    },
    {
      name: "Dwarka",
      img: "dwarka.jpg",
      desc: "One of the Char Dham pilgrimage sites associated with Lord Krishna.",
    },
    {
      name: "Jaipur",
      img: "jaipur.jpg",
      desc: "The Pink City with royal forts, palaces, and vibrant heritage markets.",
    },
    {
      name: "Jodhpur",
      img: "jodhpur.jpg",
      desc: "The Blue City dominated by the majestic Mehrangarh Fort.",
    },
    {
      name: "Udaipur",
      img: "udaipur.jpg",
      desc: "City of Lakes with stunning palaces and romantic heritage charm.",
    },
    {
      name: "Angkor Wat (Cambodia)",
      img: "angkorwat.jpg",
      desc: "World’s largest religious monument and a UNESCO World Heritage site.",
    },
  ];

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://www.api.aacoreholidaysresort.com/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        },
      );

      const data = await res.json();

      const options = {
        key: "rzp_live_RAfef3cbQ27N9l",
        amount: data.amount,
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: `${selectedDestination} Heritage Booking`,
        order_id: data.orderId,
        handler: async function (response) {
          const verifyRes = await fetch(
            "https://www.api.aacoreholidaysresort.com/api/payment_details/verify-payment",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: parseFloat(amount),
                name,
                email,
                phone_no,
                user_id,
              }),
            },
          );

          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            alert("Payment successful 🎉");
            setShowModal(false);
          } else {
            alert("Payment failed ❌");
          }
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.open();
    } catch (err) {
      alert("Payment initialization failed.");
    }
  };

  return (
    <div id="heritagedetails">
      <div
        className="heritagedetails-banner py-5"
        style={{ backgroundImage: "url(/assets/images/heritage.jpg)" }}
      >
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent">
            <li className="breadcrumb-item text-light">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item text-light">
              <Link to="/travelthemes" className="text-light">
                Travel Theme
              </Link>
            </li>
            <li className="breadcrumb-item active text-light">Heritage</li>
          </ol>
        </nav>
      </div>

      <div className="container mt-5">
        <h1 className="text-center mb-4">Heritage Destinations</h1>

        <div className="row">
          {destinations.map((place, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card">
                <img
                  src={`/assets/images/${place.img}`}
                  className="card-img-top"
                  style={{ height: "250px", objectFit: "cover" }}
                  alt={place.name}
                />
                <div className="card-body">
                  <h5 className="card-title">{place.name}</h5>
                  <p className="card-text">{place.desc}</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setSelectedDestination(place.name);
                      setShowModal(true);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Book {selectedDestination} Heritage Tour</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  placeholder="Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Phone"
                  value={phone_no}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeritageDetails;
